export default __webpack_public_path__ + "static/media/cat3.9f76854a.png";